if (!customElements.get('footer-credits')) {
  customElements.define(
    'footer-credits',
    class FooterCredits extends HTMLElement {
      constructor() {
        super();
        this.toggleButton = null;
        this.closeButton = null;
        this.bar = null;
        this.isOpen = false;

        this.scrollBaseline = 0;

        this.onToggleClick = this.onToggleClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onScroll = this.onScroll.bind(this);
      }

      connectedCallback() {
        this.toggleButton = this.querySelector('[data-credits-toggle]');
        this.closeButton = this.querySelector('[data-credits-close]');
        this.bar = this.querySelector('.footer-credits__bar');

        if (!this.toggleButton || !this.closeButton || !this.bar) {
          return;
        }

        this.setState(false);

        this.toggleButton.addEventListener('click', this.onToggleClick);
        this.closeButton.addEventListener('click', this.onCloseClick);
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.onToggleClick);
        this.closeButton?.removeEventListener('click', this.onCloseClick);
        document.removeEventListener('keydown', this.onKeydown);
        window.removeEventListener('scroll', this.onScroll);
        document.documentElement.classList.remove('footer-credits-open');
      }

      onToggleClick() {
        this.isOpen ? this.close() : this.open();
      }

      onCloseClick() {
        this.close();
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
        }
      }

      onScroll() {
        // The page-lift transform interferes with scroll-driven animations, so
        // dismiss the bar as soon as the user scrolls away from the footer.
        if (Math.abs(window.scrollY - this.scrollBaseline) > 4) {
          this.close();
        }
      }

      setState(open) {
        this.isOpen = open;

        // Lift #MainContent and the footer by the bar's exact rendered height so
        // the whole page shifts up together and reveals the bar sitting behind.
        if (open) {
          document.documentElement.style.setProperty('--footer-credits-shift', `${this.bar.offsetHeight}px`);
        }

        document.documentElement.classList.toggle('footer-credits-open', open);
        this.toggleButton.setAttribute('aria-expanded', String(open));
        this.bar.setAttribute('aria-hidden', String(!open));

        if ('inert' in this.bar) {
          this.bar.inert = !open;
        }
      }

      open() {
        if (this.isOpen) return;

        this.setState(true);
        document.addEventListener('keydown', this.onKeydown);
        this.closeButton.focus({ preventScroll: true });

        // Attach the scroll-to-close listener on the next frame so the reveal's
        // own layout settle doesn't trigger an immediate close.
        requestAnimationFrame(() => {
          if (!this.isOpen) return;
          this.scrollBaseline = window.scrollY;
          window.addEventListener('scroll', this.onScroll, { passive: true });
        });
      }

      close() {
        if (!this.isOpen) return;

        window.removeEventListener('scroll', this.onScroll);
        this.setState(false);
        document.removeEventListener('keydown', this.onKeydown);
        this.toggleButton.focus({ preventScroll: true });
      }
    },
  );
}
